import { derived, writable } from "svelte/store";
import { loadUsableCoupon } from "../backend/backendModels";
import dayjs from "dayjs";
import { dates } from "@docsndata/lang-util";
import { serviceId } from "../dateOptions";
import { applicableAccessories as applicableAccessoriesFn } from "@docsndata/thesmartwashltd-bookings-core";
export const availableTimeSlotsByDate = writable({});
export const pricedServicesByDate = writable({});
export const fromDate = writable(dayjs().toDate());
export const toDate = writable(dayjs().add(15, "day").toDate());
export const hasAvailableTimeSlots = derived(availableTimeSlotsByDate, slots => Object.keys(slots).length > 0);
export const hasPricedServices = derived(pricedServicesByDate, slots => Object.keys(slots).length > 0);
export const invitation = writable(null);
export const couponsPermitted = derived(invitation, i => i === null);
export const enteredCouponCode = writable(null);
export const enteredEmail = writable(null);
export const couponErrorMessage = writable(null);
export const isCheckingCoupon = writable(false);
export const fromDateIso = derived(fromDate, d => dates.toIso8601DateOnlyString(d));
export const toDateIso = derived(toDate, d => dates.toIso8601DateOnlyString(d));
export const fetchedCoupon = writable(null);
export const allServices = writable([]);
export const allAccessories = writable([]);
export const applicableAccessories = derived([allServices, allAccessories, serviceId], ([servicesAndAccessories, accessories, serviceId]) => applicableAccessoriesFn(serviceId, servicesAndAccessories, accessories));
export const exemplarService = derived(pricedServicesByDate, services => {
    const keys = Object.keys(services);
    if (keys.length === 0) {
        return null;
    }
    const servicesForDate = services[keys[0]];
    if (servicesForDate.length === 0) {
        return null;
    }
    return servicesForDate[0];
});
export function appendAvailableTimeSlotsByDate(slots) {
    availableTimeSlotsByDate.update(state => ({ ...state, ...slots }));
}
export function appendPricedServicesByDate(prices) {
    pricedServicesByDate.update(state => ({ ...state, ...prices }));
}
function applyCoupon(coupon) {
    fetchedCoupon.set(coupon);
}
function clearCouponCheckState() {
    couponErrorMessage.set(null);
    isCheckingCoupon.set(false);
}
export async function checkCouponCode(enteredCouponCode, emailAddress) {
    if (enteredCouponCode === null || enteredCouponCode === undefined || enteredCouponCode.trim() === "") {
        return clearCouponCheckState();
    }
    if (emailAddress === null || emailAddress === undefined || emailAddress.trim() === "") {
        return clearCouponCheckState();
    }
    try {
        clearCouponCheckState();
        isCheckingCoupon.set(true);
        const theCoupon = await loadUsableCoupon(enteredCouponCode, emailAddress);
        if (theCoupon._type === "error.message") {
            couponErrorMessage.set(theCoupon.errorMessage);
        }
        else {
            applyCoupon(theCoupon);
        }
    }
    finally {
        isCheckingCoupon.set(false);
    }
}
